module.exports = __webpack_public_path__ + "static/media/socks.850f9602.svg";